import { Injectable, Inject } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { DataIdName } from '../entities/global/model';
import { RemoveImplementModalData } from './remove-implement-modal';

@Injectable()
export class RemoveImplementModalService {
    constructor(private _http: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
    public saveRemoveImplement(data: RemoveImplementModalData): Observable<string> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('implementId', data.implementId.toString());
        params.set('jobsiteId', data.jobsiteId.toString());
        params.set('equipmentId', data.equipmentId.toString());
        params.set('smu', data.smu.toString());
        params.set('cost', data.cost.toString());
        params.set('date', data.date.toDateString());
        params.set('comment', data.comment.toString());
        params.set('statusId', data.status.toString());
        params.set('repairerId', data.repairerId.toString());
        params.set('workshopId', data.workshopId.toString());
        return this._http.get("Api/Implement/MoveImplementToInventory", { search: params }).share().map(
            (response: Response) => <string>response.json()).catch(this.handleError);
    }
}